import { Schemas } from '~/api/gen'
import { Time } from '~/components/elements/Time'
import { ClockIcon } from '~/components/icons/generated/ClockIcon'
import { dateFormatToYYYYMMDD } from '~/lib/dateUtil'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const PublishedDate: React.FC<Props> = ({ coordinate }) => {
  const publishedDateYMD = coordinate.published_at
    ? dateFormatToYYYYMMDD(coordinate.published_at)
    : ''

  return (
    <p className="flex items-center gap-[5px] text-[12px] leading-[1.8] text-gray-500 xl:leading-none xl:text-gray-600">
      <ClockIcon className="h-3 xl:h-[13px]" />
      <Time dateTime={coordinate.published_at ?? ''}>{publishedDateYMD}</Time>
    </p>
  )
}
